import { useSessionSavedFilters } from "@/shared/hooks";
import type { FilterValue } from "@/ds";

/** Filtros salvos de uma perspectiva da Carga, por usuário e separados das demais telas; aplicar reaproveita o `setFilterValue` da perspectiva. */
export function useCargaFiltrosSalvos(
  screen: string,
  aplicarFiltros: (value: FilterValue) => void,
) {
  const { savedFilters, saveFilter, deleteFilter, applySavedFilter } =
    useSessionSavedFilters(screen);

  return {
    savedFilters,
    onSaveFilter: saveFilter,
    onDeleteSavedFilter: deleteFilter,
    onApplySavedFilter: (id: string) => applySavedFilter(id, aplicarFiltros),
  };
}
